import { render, staticRenderFns } from "./SupportImg.vue?vue&type=template&id=e15cd196&scoped=true&"
import script from "./SupportImg.vue?vue&type=script&lang=js&"
export * from "./SupportImg.vue?vue&type=script&lang=js&"
import style0 from "./SupportImg.vue?vue&type=style&index=0&id=e15cd196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15cd196",
  null
  
)

export default component.exports